import React from 'react';
import {
    Grid,
    Table,
    TableRow,
    TableHeaderCell,
    TableCell
} from 'semantic-ui-react';

// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';

export default function FertilizerPrintWorksheetSignOff(): React.ReactElement {
    return (
        <div className="print-worksheet-page-section">
            <ResponsiveTable>
                <Table
                    basic="very"
                    className="basic-table || sign-off-table"
                    unstackable
                >
                    <Table.Header>
                        <TableRow>
                            <TableHeaderCell>Start time</TableHeaderCell>
                            <TableHeaderCell>End time</TableHeaderCell>
                            <TableHeaderCell>Contractor</TableHeaderCell>
                            <TableHeaderCell>{}</TableHeaderCell>
                            <TableHeaderCell>Operator sign.</TableHeaderCell>
                            <TableHeaderCell>Manager sign.</TableHeaderCell>
                        </TableRow>
                    </Table.Header>
                    <Table.Body>
                        <TableRow>
                            {/* Empty cells as the user should print and write it down */}
                            <TableCell>
                                <span aria-hidden className="empty-cell">
                                    Empty text
                                </span>
                            </TableCell>
                            <TableCell>
                                <span aria-hidden className="empty-cell">
                                    Empty text
                                </span>
                            </TableCell>
                            <TableCell>
                                <span aria-hidden className="empty-cell">
                                    Empty text
                                </span>
                            </TableCell>
                            <TableCell>
                                <span aria-hidden className="empty-cell">
                                    Empty text
                                </span>
                            </TableCell>
                            <TableCell>
                                <span aria-hidden className="empty-cell">
                                    Empty text
                                </span>
                            </TableCell>
                            <TableCell>
                                <span aria-hidden className="empty-cell">
                                    Empty text
                                </span>
                            </TableCell>
                        </TableRow>
                    </Table.Body>
                </Table>
            </ResponsiveTable>
            <Grid style={{ paddingTop: 8 }}>
                <Grid.Row>
                    <Grid.Column>
                        <span className="written-details-section">
                            Additional comments:
                        </span>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    );
}
